import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, OnInit, Output, signal } from '@angular/core';
import { BasicThemedComponentDirective, WebsiteThemes } from '@effy-tech/acquisition-core/shared';
import { EffyButtonStyle } from '@effy-tech/angular-common/button';
import { CtaButtonConnectedComponent } from '../cta/cta-button-connected/cta-button-connected.component';
import { CtaButtonComponent } from '../cta/cta-button/cta-button.component';
import { EnvironmentModel } from '../header/header';
import { IConnection } from './connection';

@Component({
  selector: 'nscf-connection',
  templateUrl: 'connection.component.html',
  styleUrls: ['connection.component.scss'],
  imports: [CtaButtonConnectedComponent, CtaButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionComponent extends BasicThemedComponentDirective implements OnInit {
  @Input() connection: IConnection;
  @Input() env: EnvironmentModel;
  @Input() isPro: boolean;
  readonly scrollOverHeight = input<boolean>();
  @Output() connected: EventEmitter<boolean> = new EventEmitter<boolean>();
  showConnection = false;
  protected readonly labelIdentity = signal('');
  readonly EffyButtonStyle = EffyButtonStyle;

  ngOnInit(): void {
    if (this.theme === WebsiteThemes.effy && !this.isPro) {
      const firstName = this.getCustomerFirstName();
      if (firstName) {
        this.labelIdentity.set(`Bonjour ${this.capitalize(firstName)}`);
      }
    }

    this.showConnection = !!this.connection?.link?.title && !!this.connection?.link?.url;
    this.connected.emit(!!this.labelIdentity());
  }

  private getCustomerFirstName(): string {
    return this.getCustomerInSessionStorage()?.customer?.data?.firstName || '';
  }

  private getCustomerInSessionStorage(): { customer?: { data?: { firstName?: string } } } | null {
    return JSON.parse(sessionStorage?.getItem('effy-customer'));
  }

  private capitalize(s: string): string {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }
}
